import { Button, ChevronLeftSVG, Icon } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";

import {
  editFormFooterButtonsWrapperCss,
  modalFooterCss,
} from "../CitationModal.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

interface CitationModalFooterProps {
  showEditForm: boolean;
  setShowEditForm: (show: boolean) => void;
  setActive: (active: boolean) => void;
  onSaveEdits: () => void;
}

const CitationModalFooter = ({
  showEditForm,
  setShowEditForm,
  setActive,
  onSaveEdits,
}: CitationModalFooterProps) => {
  if (showEditForm) {
    return (
      <div css={editFormFooterButtonsWrapperCss}>
        <ButtonWithTrackEvent
          flavor={Button.flavors.tertiary}
          actionName={actionNames.cancel}
          onClick={() => setShowEditForm(false)}
          objectType={objectTypes.generatedTextAsset}
          dataProps={{
            "data-qa-selector": "citation-edit-return-button",
          }}
        >
          <Icon SvgComponent={ChevronLeftSVG} />
          Cancel
        </ButtonWithTrackEvent>

        <ButtonWithTrackEvent
          actionName={actionNames.save}
          onClick={onSaveEdits}
          objectType={objectTypes.generatedTextAsset}
          dataProps={{
            "data-qa-selector": "citation-edit-save-button",
          }}
        >
          Save Edits
        </ButtonWithTrackEvent>
      </div>
    );
  }

  return (
    <div css={modalFooterCss}>
      <ButtonWithTrackEvent
        objectType={objectTypes.generatedTextAsset}
        actionName={actionNames.finish}
        onClick={() => {
          setShowEditForm(false);
          setActive(false);
        }}
        dataProps={{
          "data-qa-selector": "citation-done-button",
        }}
      >
        Done
      </ButtonWithTrackEvent>
    </div>
  );
};

export default CitationModalFooter;
